"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var styles_1 = require("@material-ui/core/styles");
var dealerPageInfoStyles = styles_1.makeStyles(function (theme) { return ({
    infoContainer: {
        display: 'flex',
    },
    info: {
        color: theme.palette.text.disabled,
    },
}); }, { name: 'GqlCheckout_DealerPageInfo' });
exports.default = dealerPageInfoStyles;
